<template>
	<el-container>
		<el-header style="height:auto">
			<Head/>
		</el-header>
		<el-main>
			<router-view></router-view>
		</el-main>
		<el-footer style="height:auto">
			<Footer/>
		</el-footer>
	</el-container>
</template>

<script>
import Head from './components/Head.vue'
import Main from './components/Main.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'app',
  components: {
    Head,
	Main,
	Footer
  }, 

  data() {
  	return{


	}
  },
  mounted() {
	  
  }
}
</script>

<style>

</style>
